export enum PreviewModal {
  Chat = 'Chat',
  Documents = 'Documents',
  Information = 'Information',
}
